
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import marketmanager from '../../../images/footerLinksImages/enterpreneur/marketingmanaer.jpg'
function MarketManager() {

    const keywords = [
        { title: "Digital Marketing Strategy", summary: "Learn how to create effective digital marketing strategies to boost brand awareness and sales across online platforms." },
        { title: "Search Engine Optimization (SEO)", summary: "Master SEO techniques to enhance website visibility, improve organic search rankings, and attract quality traffic." },
        { title: "Social Media Marketing", summary: "Harness the power of social media platforms to engage with your audience and build a loyal community." },
        { title: "Email Marketing Campaigns", summary: "Design and implement email marketing campaigns that nurture leads and drive conversions." },
        { title: "Content Marketing", summary: "Develop a content marketing plan to attract, engage, and convert customers with relevant and valuable content." },
        { title: "Paid Advertising (PPC)", summary: "Utilize pay-per-click advertising on platforms like Google and social media to drive targeted traffic and increase sales." },
        { title: "Brand Management", summary: "Learn how to manage and grow a brand online, ensuring a consistent message and strong market presence." },
        { title: "Marketing Automation Tools", summary: "Streamline marketing processes using automation tools to save time, optimize campaigns, and increase efficiency." },
        { title: "Influencer Marketing", summary: "Collaborate with influencers to promote products or services and expand your brand’s reach." },
        { title: "Data Analytics for Marketing", summary: "Use data analytics to track, analyze, and optimize marketing campaigns for better results and ROI." }
      ];
    return (<>
        <Header />
      
        <BannerFooter
            title="Maeket Manager"
            text="Are you a strategic thinker with a passion for driving results in trading and web technology? We’re seeking a dynamic Marketing Manager to lead innovative campaigns that elevate our brand in these fast-evolving industries. You’ll oversee the development of strategies to promote trading solutions and web technologies, manage multi-channel campaigns, and guide a talented team to achieve ambitious goals. Your expertise in market analysis, team leadership, and performance optimization will be key in connecting with our audience and expanding our reach. If you’re ready to make an impact in a leadership role, we’d love to have you onboard!"
            imageone={marketmanager}
            imagetwo={marketmanager}
        />

        
<div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Online Marketing for Marketing Managers</h2>
    <div className="accordion" id="marketingManagerAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#marketingManagerAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default MarketManager